module.exports = __webpack_public_path__ + "43acdd46beda5bcd20313cc5ad7e524e.ttf";